export default {
  'empty-list': 'Aucune recette disponible pour le moment',
};
